import { VinylsEditorComponent } from "./vinylsEditorComponent/VinylsEditorComponent"
import './VinylsEditorMenu.css'

interface VinylsEditorMenuProps {
    selectedEditorMode: 'Q' | 'W' | 'E' | 'R';
    setSelectedEditorMode: (mode: 'Q' | 'W' | 'E' | 'R') => void;
}

export const VinylsEditorMenu = ({ selectedEditorMode, setSelectedEditorMode }: VinylsEditorMenuProps) => {
    return (
        <div className="vinyls-editor-menu">
            <VinylsEditorComponent 
                name={"move"} 
                button={"Q"} 
                isActive={selectedEditorMode === "Q"} 
                onClick={() => setSelectedEditorMode("Q")} 
            />
            <VinylsEditorComponent 
                name={"rotate"} 
                button={"W"} 
                isActive={selectedEditorMode === "W"} 
                onClick={() => setSelectedEditorMode("W")} 
            />
            <VinylsEditorComponent 
                name={"scale"} 
                button={"E"} 
                isActive={selectedEditorMode === "E"} 
                onClick={() => setSelectedEditorMode("E")} 
            />
            <VinylsEditorComponent 
                name={"palette"} 
                button={"R"} 
                isActive={selectedEditorMode === "R"} 
                onClick={() => setSelectedEditorMode("R")} 
            />
        </div>
    )
}